export default __webpack_public_path__ + "static/media/15_2_0.e5bccdd8.png";